import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { SharedTeltonikaSingletonService } from '@huge-monorepo/shared/services';
import { IHIPTeltonikaService, ICustomerTeltonikaService, TeltonikaDeviceLANIPs } from '@huge-monorepo/shared/interfaces';
import { TeltonikaConnectedDevice } from '@huge-monorepo/shared/interfaces';
import { UntypedFormControl } from '@angular/forms';
import { RefreshData } from '@huge-monorepo/shared/components';

@Component({
  selector: 'huge-monorepo-teltonika-device-ports',
  standalone: true,
  imports: [CommonModule, MatCardModule, MaterialModule],
  templateUrl: './teltonika-device-ports.component.html',
  styleUrl: './teltonika-device-ports.component.scss',
})
export class TeltonikaDevicePortsComponent implements OnInit {
  teltonikaService = this.sharedTeltonikaService.getService();
  ports: { id: number, name: string, Num: number, devices: any[], position: number, state: string, topology: { MAC: string, Vendor: string, VID: number }[] }[] = [];
  selectedPort: { id: number, name: string, Num: number, devices: any[], position: number, topology: { MAC: string, Vendor: string, VID: number }[] } = this.ports[0];
  displayPorts: boolean = true;
  devices: DeviceInfo[] = [];
  loading: boolean = true;
  errorOnLoading: boolean = false;
  connectedDevices: TeltonikaConnectedDevice[] = [];
  filteredDevices: TeltonikaConnectedDevice[] = [];
  searchTerm: string = '';
  lanIPsLoading: boolean = true;
  errorLanIPs: boolean = false;
  lanIPs: string[] | null = null;
  wanIPs: string[] | null = null;
  id: number = 0;

  constructor(
    private sharedTeltonikaService: SharedTeltonikaSingletonService<ICustomerTeltonikaService | IHIPTeltonikaService>,
    private activatedRoute: ActivatedRoute) { }
  ngOnInit(): void {
    this.loading = true;
    this.errorOnLoading = false;
    this.activatedRoute.paramMap.subscribe(
      (paraMap: any) => {
        if (paraMap.params.id) {
          let id = paraMap.params.id;
          this.id = id;
          this.getPortData(id);
          this.getDevicesLANIPs(id);
        }
      }

    );
  }

  getPortData(id: number) {
    this.teltonikaService.getPortInfo(id).subscribe({
      next: (data) => {
        this.ports = data.Ports.map((port, index) => {
          let dev: TeltonikaConnectedDevice[] = [];
          // We should not be showing CPU/WiFi port for now as it is most likely just a bridge on the device, return as null
          if (port.Name != 'CPU/WiFi') {
            if (port.Topology) {
              port.Topology.forEach((topologyDevice) => {
                const foundDevice = data.ConnectedDevices.filter(
                  (device) => device.MAC === topologyDevice.MAC
                );
                if (foundDevice && foundDevice.length > 0) dev.push(...foundDevice);
              });
            }

            return {
              id: index,
              name: port.Name,
              Num: port.Num,
              position: port.Position,
              devices: dev,
              state: port.State,
              topology: port.Topology,
            };
          }
          return null;
        });

        // Remove the null value returned when evaluating the CPU/WiFi port
        this.ports = this.ports.filter((port) => port != null);

        this.ports.sort((a, b) => a.Num - b.Num);
        this.selectedPort = this.ports[0];
        this.connectedDevices = data.ConnectedDevices.map((device) => {
          let correspondingPort = this.ports.find((port) => port.devices.find((dev) => dev.MAC === device.MAC));

          return {
            IP: device.IP,
            MAC: device.MAC,
            Vendor: device.Vendor,
            Hostname: device.Hostname,
            Interface: device.Interface,
            Type: device.Type,
            //The following adds the port name to the device but if the port is LAN it will add the position else it will just display the name
            CurrentPort: correspondingPort ? (correspondingPort.name === "LAN" ? correspondingPort.name + " " + correspondingPort.position : correspondingPort.name) : ''
          }
        });

        this.filteredDevices = this.connectedDevices;

        this.loading = false;
        this.errorOnLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.loading = false;
        this.errorOnLoading = true;
      },
    });
  }

  getPortImage(port: any): string {
    const basePath = 'assets/Teltonika/';
    if (port.name === 'LAN') {
      // LAN logic uses position
      return `${basePath}${port.state === 'up' ? 'Green' : 'Grey'} - Port ${port.position}.svg`;
    } else if (port.name === 'WAN') {
      // WAN logic
      return `${basePath}${port.state === 'up' ? 'Green' : 'Grey'} - Port WAN.svg`;
    }
    // This is commented out because WIFI shouldn't be displayed for now
    // else if (port.name === 'CPU/WiFi') {
    //   // CPU/WIFI logic
    //   return `${basePath}${port.state === 'up' ? 'Green' : 'Grey'} - Port Wifi.svg`;
    // }
    // Default fallback if none match (optional)
    return `${basePath}Unknown - Port.svg`;
  }

  getDevicesLANIPs(id: number) {
    this.lanIPsLoading = true;
    this.errorLanIPs = false;
    this.teltonikaService.getTeltonikaDeviceLANIPs(id).subscribe({
      next: (data: TeltonikaDeviceLANIPs) => {
        this.lanIPs = data.LanIPV4Addresses;
        this.wanIPs = data.WanIPV4Addresses;
        this.lanIPsLoading = false;
      },
      error: (error) => {
        console.error(error);
        this.lanIPsLoading = false;
        this.errorLanIPs = true;
      },
    });
  }
}

interface DeviceInfo {
  ipv4: string;
  mac: string;
  vendor: string;
}
